import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideStop = ({ width = 16, height = 16, color = '#FFFFFF' }) =>
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M4 4H12V12H4V4Z' fill={color} />
    </svg>;

IconPowertrainGuideStop.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideStop;
